(function () {
  'use strict';

  /* ── Header scroll state ───────────────────────────────────────────────── */
  var header = document.getElementById('site-header');

  if (header) {
    var onScroll = function () {
      if (window.scrollY > 60) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();
